import { fetchAcademyApi } from '../../services/academy-api'

export const fetchFooterApi = async (language, version) => fetchAcademyApi(`/academy/footer/${language}/${version}`)



// WEBPACK FOOTER //
// ./src/containers/Footer/services.js